import { ChakraProps } from "@chakra-ui/react";
import React, { useCallback } from "react";
import useTaskLocations from "../../hooks/tasks/useTaskLocations";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";

interface SelectTaskLocationProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectTaskLocation: React.FC<SelectTaskLocationProps> = ({ color, value, setValue, ...chakraProps }) => {
  const { isLoading, error, taskLocations = [] } = useTaskLocations();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      return taskLocations
        .filter((displayName) => displayName.toLowerCase().includes(searchQuery?.toLowerCase().trim() ?? ""))
        .sort((a, b) => a.localeCompare(b))
        .map((displayName) => [displayName, displayName]);
    },
    [taskLocations]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        color={color}
        title={"Task Location"}
        isLoading={isLoading}
        error={error}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectTaskLocation;
